// extracted by mini-css-extract-plugin
export default {"popup":"Popup--popup--I0qGS","contents":"Popup--contents--isjoC","arrow":"Popup--arrow--FJXYY"};